import { LeadTimeAggregateBusinessIdPutRequest } from '@/coreInfrastructureModule/axios/generated/aggregateBusinessManage';
import { DateUnitType } from '@/coreDomainsModule/date';
import { getLeadTimeForSpanText } from '@/appLogic/business/inventorySimulation';

/**
 * UI用の型をAPIリクエストの型に変換する
 */
export class PutLeadTimeAdapter {
  /**
   * フロント側の型に変換を行う
   * @param leadTimeValue - リードタイムの値
   * @param leadTimeUnit - リードタイムの単位
   */
  public static adapt = (leadTimeValue: number, leadTimeUnit: DateUnitType): LeadTimeAggregateBusinessIdPutRequest => {
    return {
      putLeadTimeRequestInfo: {
        leadTime: getLeadTimeForSpanText(leadTimeValue, leadTimeUnit),
        leadTimeUnit: leadTimeUnit,
      },
    };
  };
}
